import { Link } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import useQuery from '../../../hooks/useQuery';
import { CalendarScheduledIcon } from '../../../assets/icons';
import useCommonStyles from '../../../styles/common';

const AppointmentOk = () => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const query = useQuery();

  const getReservationId = () => query.get('reservationId');

  return (
    <Container component="section" className={classes.container}>
      <Box component="figure" className={classes.iconContainer}>
        <img src={CalendarScheduledIcon} alt="CalendarScheduledIcon" draggable="false" />
        <Typography variant="h2">Seu agendamento foi realizado com sucesso!</Typography>
      </Box>

      <Button component={Link} to={`/meu-agendamento/${getReservationId()}`} className={commonClasses.outlinedButton}>
        Ver meu Agendamento
      </Button>
    </Container>
  );
}

export default AppointmentOk;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      width: '100%',
      height: '100%',
      minHeight: '50vh',
      padding: theme.spacing(0, 2, 2),

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',

      '& h2': {
        marginTop: theme.spacing(2),
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: '25px',
      },
    },

    iconContainer: {
      width: '100%',
      padding: theme.spacing(0, 6),
      textAlign: 'center',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& img': {
        width: '100%',
        height: 'auto',
        maxWidth: 120,
        filter: 'drop-shadow(0px 5px 10px #21212133)',
      },
    },

    buttonsContainer: {
      marginTop: theme.spacing(4),
      justifyContent: 'center',
      alignItems: 'center',
    },
    button: {
      marginTop: 'unset',
    },
  })
);
